(() => {
  function mount(root) {
    const input = root.querySelector('#faq-search');
    if (!input || input.dataset.searchReady) return;
    input.dataset.searchReady = 'true';
    const normalize = value => value.toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
    const items = [...root.querySelectorAll('[data-koppa-faq-item]')].map(element => ({element, text: normalize(element.textContent)}));
    const status = root.querySelector('[data-faq-search-status]');
    const filter = () => {
      const terms = normalize(input.value).split(' ').filter(Boolean);
      let count = 0;
      items.forEach(({element, text}) => { element.hidden = !terms.every(term => text.includes(term)); if (!element.hidden) count++; });
      root.querySelectorAll('[data-koppa-faq-group]').forEach(group => { group.hidden = !group.querySelector('[data-koppa-faq-item]:not([hidden])'); });
      root.querySelectorAll('[data-koppa-faq-promo]').forEach(promo => { promo.hidden = terms.length > 0; });
      status.hidden = !terms.length;
      status.textContent = count ? `${count} ${count === 1 ? 'answer' : 'answers'} found.` : 'No matching answers. Try a different word or contact us for help.';
    };
    input.addEventListener('input', filter);
    input.addEventListener('search', filter);
    input.addEventListener('keydown', event => { if (event.key === 'Escape') { input.value = ''; filter(); } });
    const openHash = () => { const id = decodeURIComponent(location.hash.slice(1)); const item = items.find(({element}) => element.id === id); if (item) item.element.open = true; };
    openHash(); window.addEventListener('hashchange', openHash);
  }
  const scan = () => document.querySelectorAll('[data-ploy-page="faq"]').forEach(mount);
  scan(); document.addEventListener('shopify:section:load', scan);
})();
